import { Component } from '@angular/core';
import { Store, createSelector } from '@ngrx/store';

import { FullUserFragment } from 'graphql.generated';
import { FreyaCommonModule } from 'src/app/freya-common/freya-common.module';
import { isErrorState, LoadingState } from 'src/app/utilities/state.util';

import { NewOpportunitySearchCustomersDialogActions } from './new-opportunity-search-customers-dialog.actions';
import { newOpportunitySearchCustomersDialogFeature } from './new-opportunity-search-customers-dialog.feature';

type CustomerOption = {
  id: string;
  customer: FullUserFragment;
  name: string;
  email: string;
  phone: string;
  company: string;
  contact: string;
};

@Component({
  selector: 'app-new-opportunity-search-customers-dialog',
  standalone: true,
  imports: [
    FreyaCommonModule,
  ],
  templateUrl: './new-opportunity-search-customers-dialog.component.html',
  styleUrls: ['./new-opportunity-search-customers-dialog.component.scss'],
})
export class NewOpportunitySearchCustomersDialogComponent {
  viewModel$ = this.store.select(createSelector({
    show: newOpportunitySearchCustomersDialogFeature.selectShow,
    query: newOpportunitySearchCustomersDialogFeature.selectQuery,
    customers: createSelector(
      newOpportunitySearchCustomersDialogFeature.selectCustomers,
      (customers): CustomerOption[] => customers.map((customer) => {
        const name = [customer.givenName, customer.familyName].filter(Boolean).join(' ') || '--';
        const email = customer.email || '';
        const phone = customer.phone || '';
        const company = customer.company || '';

        return {
          id: customer.id,
          customer,
          name,
          email,
          phone,
          company,
          contact: email || phone || '--',
        };
      }),
    ),
    emptyMessage: createSelector(
      newOpportunitySearchCustomersDialogFeature.selectCallState,
      (callState) => {
        if (isErrorState(callState)) {
          const errorMessage = callState.error instanceof Error ? callState.error.message : String(callState.error);
          return `Error searching customers: ${errorMessage}`;
        }

        if (callState === LoadingState.LOADING) {
          return 'Searching customers...';
        }

        if (callState === LoadingState.INIT) {
          return 'Type to search customers by name, email, phone, or company.';
        }

        return 'No customers found';
      },
    ),
  }));

  actions = NewOpportunitySearchCustomersDialogActions;

  constructor(public store: Store) {}
}
